module.exports = __webpack_public_path__ + "static/img/1-blue.bc3424c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1-blue.png
// module id = NJ1G
// module chunks = 0